import { IFormField } from '../IForm.types';
import { ItemForm } from './ItemForm';

export class InputRadioForm extends ItemForm {
  inputType = 'radio';
  override dataGridLabel = true;
  override labelPosition = 'right';
  type = 'radio';
  style = {
    'margin-left': 'auto',
  };
  values: any;

  constructor(field: IFormField) {
    super(field);
    this.values = field.admittedValues
      .split(',')
      .map((v) => v.trim())
      .map((value) => ({ value, label: value }));
  }
}
